import type { VariantDefinition } from '../factory';

export const buttonDefinition = {
  variants: {
    variant: {
      default: 'bg-primary text-white',
      destructive: 'bg-magenta text-white',
      outline: 'border border-input bg-background text-foreground',
      secondary: 'bg-orange text-secondary-foreground',
      ghost: 'bg-transparent text-foreground',
      link: 'bg-transparent text-primary underline underline-offset-4',
    },
    size: {
      default: 'h-11 px-4 py-0',
      sm: 'h-10 px-3 py-0',
      lg: 'h-12 px-6 py-0',
      icon: 'h-11 w-11 py-0',
    },
    disabled: {
      true: 'opacity-50',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
    disabled: 'false',
  },
} satisfies VariantDefinition;

export const buttonTextDefinition = {
  variants: {
    variant: {
      default: 'text-white',
      destructive: 'text-white',
      outline: 'text-foreground',
      secondary: 'text-secondary-foreground',
      ghost: 'text-foreground',
      link: 'text-primary underline',
    },
    size: {
      sm: 'text-sm',
      default: 'text-sm',
      lg: 'text-base',
      icon: 'text-sm',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
} satisfies VariantDefinition;

export type ButtonVariant = keyof typeof buttonDefinition.variants.variant;
export type ButtonSize = keyof typeof buttonDefinition.variants.size;
